"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapNavigationData = void 0;
var _net = require("../models/graphql-types/net");
const mapNavigationData = data => (data ?? []).filter(item => !!item).map(item => ({
  children: mapNavigationData(item.children ?? []),
  linkType: item.linkType ?? _net.NavigationLinkType.None,
  type: item.type ?? null,
  description: item.description ?? null,
  id: item.id ?? null,
  imageUrl: item.imageUrl ?? null,
  title: item.title ?? null,
  url: item.link?.relativeUrl ?? null
}));
exports.mapNavigationData = mapNavigationData;
